export const enTranslations = {
  errorBoundary: {
    title: 'Oops, something went wrong',
    message: 'An unexpected problem occurred. You can try again.',
  },
  api: {
    'ContactRequest.AlreadyExists': 'You have already sent a contact request to this user',
    'Global.OperationNotAllowedError': 'You are not allowed to perform this operation',
    'Global.ResourceDeletionNotAllowedError': 'You are not allowed to delete this resource',
    'Global.ResourceNotFoundError': 'The resource was not found',
    'IdentityAndAccess.InvalidCredentialsError': 'The email or password is incorrect',
    'IdentityAndAccess.EmailAlreadyTakenError': 'The email is already taken',
    'Networking.CannotCancelNonPendingContactRequestError':
      'You cannot cancel a contact request that is not in the PENDING status',
    'Networking.OnboardingAlreadyCompleteError':
      'You have already completed the onboarding process',
    'Notifications.DeviceAlreadyRegisteredError': 'The device is already registered',
    'Networking.GhostProfileNoEmailError':
      'This profile has no email address. Add an email to send an invitation.',
    NetworkError: 'Network error. Please check your internet connection',
  },
  tabNavigation: {
    home: 'Home',
    contacts: 'Contacts',
    messages: 'Messages',
    notifications: 'Notifications',
    chatbot: 'AI Assistant',
    profile: 'Menu',
  },
  chatbot: {
    title: 'AI Assistant',
    placeholder: 'Ask me anything...',
    thinking: 'Thinking...',
    error: 'An error occurred. Please try again.',
    welcome:
      'Hello! I am your AI assistant. I can help you manage your contacts, notes, categories and hashtags. How can I help you?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    actionConfirmed: 'Action confirmed.',
    actionCancelled: 'Action cancelled.',
    suggestionsTitle: 'Here are a few examples:',
    suggestions: {
      notes: 'Search through all my notes',
      conversations: 'Summarise my latest LinkedIn conversation',
      sector: 'Who works in cybersecurity?',
      calendar: 'What are my upcoming appointments?',
      birthdays: 'Which birthdays are coming up?',
      findContact: 'Help me find a contact',
    },
  },
  welcome: {
    title: 'KEEPTOUCH',
    tagline: 'A single contact can change a whole life.',
    connection: 'Connection',
    registration: 'Registration',
    slogan: 'Keep, manage your contacts of tomorrow \n Find and accomplish common projects',
  },
  login: {
    title: 'Log in',
    email: 'Email address',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    button: 'Login',
    noAccount: "I don't have an account",
    or: 'Or',
    error: {
      noInfo: 'Enter your information',
      wrongCredentials: 'The email or password is incorrect',
    },
  },
  register: {
    title: 'Sign up',
    email: 'Email address',
    password: 'Password',
    confirmPassword: 'Re-enter password',
    button: 'Sign up',
    haveAccount: 'I already have an account',
    or: 'Or',
    error: {
      noInfo: 'Enter your information',
      notSamePassword: 'The passwords do not match',
    },
  },
  registerSteps: {
    step2: 'What do you prefer? #',
    step3: 'The best time to contact you?',
    skip: 'Skip',
  },
  registerStep1: {
    title: {
      picture: 'Add your profile picture:',
      gender: 'You are:',
      name: 'Your first name:',
      surname: 'Your last name:',
      birthday: 'Your birthday:',
      athletic: 'Are you sporty:',
      info: 'About you:',
      languages: 'Which languages do you speak:',
      nationality: 'What is your nationality:',
      origin: 'What is your origin:',
      personality: 'What is your personality:',
      residence: 'Where do you live:',
      smoker: 'Do you smoke:',
      conditions: 'I accept the conditions',
    },
    value: {
      women: 'A woman',
      man: 'A man',
      nonBinary: 'A non-binary',
      other: 'Other',
      yes: 'Yes',
      no: 'No',
      calm: 'Calm',
      active: 'Active',
      talkative: 'Talkative',
    },
    next: 'Next',
  },
  registerStepHastags: {
    mainTitle: 'What defines you #',
    title: 'Which hashtags match you',
    placeholder: '#sport',
    next: 'Next',
  },
  registerStep3: {
    mainTitle: 'The best time to contact you?',
    title: 'Select the times when you are most available',
    aperitif: 'Aperitif',
    breakfast: 'Breakfast',
    coffee: 'Coffee',
    dinner: 'Dinner',
    lunch: 'Lunch',
    walk: 'Walk',
    videoCall: 'Video call',
    phoneCall: 'Phone call',
    weekend: 'Weekend',
    sport: 'Sport',
    event: 'Event',
    next: 'Next',
  },
  registerStep4: {
    aperitif: 'Aperitif',
    breakfast: 'Breakfast',
    coffee: 'Coffee',
    dinner: 'Dinner',
    lunch: 'Lunch',
    walk: 'Walk',
    videoCall: 'Video call',
    phoneCall: 'Phone call',
    weekend: 'Weekend',
    sport: 'Sport',
    event: 'Event',
    next: 'Next',
  },
  registerFinalStep: {
    congrats: 'Congratulations,\n{name} {surname},\n your account has been created',
    next: 'Next',
    geolocationText: 'Enable geolocation for a better user experience',
  },
  forgotPassword: {
    title: 'Reset password',
    email: 'Email address',
    emailConfirm: 'Confirm email address',
    button: 'Send link by email',
    success: 'If an account exists with this email, you will receive a reset link shortly.',
    error: {
      noEmail: 'Please enter your email address.',
      generic: 'Something went wrong. Please try again later.',
    },
  },
  resetPassword: {
    title: 'Set new password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    button: 'Reset password',
    success: 'Your password has been reset. You can now sign in.',
    error: {
      noToken: 'Invalid or missing reset link. Please request a new one.',
      passwordTooShort: 'Password must be at least 8 characters.',
      passwordMismatch: 'Passwords do not match.',
      generic: 'The reset link may have expired. Please request a new one.',
    },
  },
  contact: {
    title: 'Contacts',
    searchPlaceholder: 'Search for a contact',
    commonContacts: '{nbr} contacts{newline} in common',
    commonProjects: '{nbr} projects{newline} in common',
    addButton: 'Add',
    addTitle: 'Add {name} to your profile ',
    commonTitleModal: 'Friends and projects in common',
    filter: {
      search: 'Search',
      category: {
        location: 'Locations',
        origin: 'Origin',
        role: 'Function',
        degree: 'Degree',
        hashtag: '#',
      },
      location: {
        continent: 'Continent',
        country: 'Search for a country',
        region: 'States / Region',
      },
      nonLocation: {
        origin: 'Search for an origin',
        role: 'Search for a function',
        hashtag: 'Search by #',
      },
    },
    emptyReceivedRequest: 'No requests received for now',
    emptySentRequest: 'No requests sent for now',
    emptyContactPro: 'No professional contacts',
    emptyContactPrivate: 'No private contacts',
  },
  addContact: {
    title: 'Search for a contact',
    commonContacts: '{nbr} contacts{newline} in common',
    commonProjects: '{nbr} projects{newline} in common',
    addButton: 'Add',
    addTitle: 'Add {name} to your profile ',
    commonTitleModal: 'Friends and projects in common',
    filter: {
      search: 'Search',
      category: {
        location: 'Locations',
        origin: 'Origin',
        role: 'Function',
        degree: 'Degree',
        hashtag: '#',
      },
      location: {
        continent: 'Continent',
        country: 'Search for a country',
        region: 'States / Region',
      },
      nonLocation: {
        origin: 'Search for an origin',
        role: 'Search for a function',
        hashtag: 'Search by #',
      },
    },
    emptyData: 'No suggested contacts',
    degree1: '1st',
    degree2: '2nd',
    degree3: '3rd',
  },
  requestContact: {
    received: 'Received',
    sended: 'Sent',
  },
  menu: {
    profileButton: 'View profile',
    nonExistentProfile: 'Non-existent profile',
    share: 'Share',
    settings: 'Settings',
    signOut: 'Sign out',
    version: 'Version {version}',
  },
  contactType: {
    PRIVATE: 'Private',
    PROFESSIONAL: 'Pro',
    GROUP: 'Group',
    OTHERS: 'Others',
    GHOST: 'Ghost',
  },
  profile: {
    premiumTitle: 'Try Premium',
    mainMenus: {
      updateProfile: 'Edit Profile',
      shareProfile: 'Share Profile',
      calendar: 'Calendar',
      memories: 'Memories',
    },
    hashtags: {
      blocTitle: 'Skills',
      learn: {
        title: 'Learn',
        placeholder: 'Search your goals ...',
      },
      target: {
        title: 'Goal',
        placeholder: 'build a house ...',
      },
      hobby: {
        title: 'Hobby',
        placeholder: '# do karate ...',
      },
      skill: {
        title: 'Skills',
        placeholder: 'Marketing ...',
      },
      button: 'Save',
    },
    contact: {
      email: {
        title: 'Email',
      },
      phoneNumber: {
        title: 'Phone Number',
      },
      website: {
        title: 'Website',
      },
      fbProfile: {
        title: 'Facebook Profile',
      },
      instagramProfile: {
        title: 'Instagram Profile',
      },
      linkedinProfile: {
        title: 'LinkedIn Profile',
      },
      twitterProfile: {
        title: 'Twitter Profile',
      },
      availability: 'Availabiity',
      contact: 'Contact',
    },
    presentation: {
      title: 'Presentation',
    },
    question: {
      title: 'Question',
      button: 'Save',
      nationalities: {
        title: 'What are your nationalities:',
        placeholder: 'Search for a nationality...',
      },
      origins: {
        title: 'What are your origins:',
        placeholder: 'Search for an origin...',
      },
      languages: {
        title: 'What languages do you speak:',
        placeholder: 'Search for a language...',
        modal: {
          title: 'Select a country',
          search: {
            placeholder: 'Search for a country...',
          },
        },
      },
      countries: {
        title: 'Which countries have you visited:',
        placeholder: 'Search for a country...',
      },
      addLanguage: {
        title: 'Add a language',
        button: 'Save',
        language: {
          title: 'Language',
          placeholder: 'Select a language',
        },
        level: {
          title: 'Level',
          placeholder: 'Select your level',
          beginner: 'Beginner',
          intermediate: 'Intermediate',
          advanced: 'Advanced',
          expert: 'Expert',
        },
      },
    },
    livingPlaces: {
      title: 'Places of residence',
      addLivingPlace: {
        title: 'Add a place of residence',
        button: 'Save',
        country: {
          title: 'Country',
          placeholder: 'Select a country',
        },
        from: {
          title: 'From',
        },
        to: {
          title: 'To',
        },
      },
    },
    updateSuccess: 'Profile updated',
    about: {
      title: 'Learn more',
      save: 'Save',
      categories: {
        learn: {
          title: 'What do you want to learn?',
          placeholder: 'Search your goals...',
        },
        objective: {
          title: 'Objective',
          placeholder: '#build a house...',
        },
        hobby: {
          title: 'Hobby',
          placeholder: '# do karate...',
        },
        skills: {
          title: 'Skills',
          placeholder: '# Marketing...',
        },
      },
    },
  },
  search: {
    placeholder: 'Search',
  },
  imageUpload: {
    fromCamera: 'Take a photo',
    fromGallery: 'Import from phone',
  },
  swipeable: {
    mute: 'Mute',
    pin: 'Pin',
    unpin: 'Unpin',
    delete: 'Delete',
  },
  errors: {
    title: 'A problem has occurred',
    logError: 'Please log in again',
    generic: 'Something went wrong. Please try again.',
    'Global.ResourceNotFoundError': 'Resource not found.',
    'Global.OperationNotAllowed': 'Operation not allowed.',
    'Global.PermissionDenied': "You don't have permission to do this.",
    'Global.ResourceDeletionNotAllowed': 'This resource cannot be deleted.',
    'Identity.Authentication.Unauthenticated': 'Please sign in again.',
    'Identity.SignIn.InvalidCredentials': 'Wrong email or password.',
    'Identity.SignUp.EmailAlreadyTaken': 'This email is already taken.',
    'Identity.ResetPassword.InvalidOrExpiredToken': 'The reset link is invalid or has expired.',
    'Networking.ContactRequest.SelfContactRequest':
      'You cannot send a contact request to yourself.',
    'Networking.ContactRequest.AlreadyExists': 'A contact request already exists with this person.',
    'Networking.ContactRequest.NotFound': 'Contact request not found.',
    'Networking.Note.SharedNoteRequiresContact': 'A shared note must be linked to a contact.',
    'Networking.Note.CannotShareWithSelf': 'You cannot share a note with yourself.',
    'Networking.Note.OnlyCreatorOrContactCanUpdate':
      'Only the creator or related contact can update this note.',
    'Networking.Note.SharedNoteContactMustDifferFromAuthor':
      "A shared note's contact must differ from the author.",
    'Networking.KeepContact.OnlyCreatorCanUpdate': 'Only the creator can update this reminder.',
    'Networking.KeepContact.ContactNotFound': 'Contact not found.',
    'Networking.CalendarEvent.OnlyCreatorCanUpdate': 'Only the creator can update this event.',
    'Networking.CalendarEvent.SomeParticipantsNotFound': 'Some participants were not found.',
    'Networking.ScheduledMessage.RecipientOrGroupRequired': 'Please select a recipient or a group.',
    'Networking.ScheduledMessage.GroupNotFoundOrNotMember':
      'Group not found or you are not a member.',
    'Networking.ScheduledMessage.OnlyCreatorCanUpdate':
      'Only the creator can update this scheduled message.',
    'Networking.ScheduledMessage.ContactNotFound': 'Contact not found.',
    'Networking.UpdateContactScope.GhostNotAllowed': 'Scope can only be changed for real contacts.',
    'Networking.Profile.OnlyOwnerCanUpdate': 'Only the profile owner can update it.',
    'Networking.Hashtag.OnlyCreatorCanUpdate': 'Only the creator can update this hashtag.',
    'Networking.Contact.ProfileNotFound': 'Contact profile not found.',
    'Networking.Contact.RelationshipNotFound': 'Contact relationship not found.',
    'Networking.GhostProfile.NotFound': 'Ghost profile not found.',
    'Networking.GhostProfile.NoEmail': 'This ghost profile has no email on file.',
    'Networking.MergeContacts.GhostNotFoundOrNotOwned':
      'Ghost profile not found or not owned by you.',
    'Networking.MergeContacts.RealContactNotFound': 'Real contact not found in your contacts.',
    'Networking.Profile.NotFoundOrNoRelationship': 'Profile not found or no contact relationship.',
    'Networking.Conversation.NotFound': 'Conversation not found.',
    'Ft.Chatbot.ConfirmFailed': 'Confirming the action failed.',
    'Ft.Chatbot.ChatFailed': 'Processing the chatbot message failed.',
    'Ft.VoiceNote.NoAudioFile': 'No audio file provided.',
    'Ft.VoiceNote.ProcessingFailed': 'Processing the voice note failed.',
    'Ft.ConversationAi.AnalyzeFailed': 'Analyzing the conversation failed.',
    'Ft.ConversationAi.GenerateFailed': 'Generating suggestions failed.',
    'Ft.ConversationAi.SummarizeFailed': 'Summarizing the conversation failed.',
    'Ft.BusinessCard.NoImageFile': 'No image provided.',
    'Ft.BusinessCard.ScanFailed': 'Scanning the business card failed.',
    'Ft.SocialImport.ImportNotFound': 'Import not found.',
    'Ft.SocialImport.ResultsNotReady': 'Import results are not ready yet.',
    'Ft.SocialImport.NetworkNotEnabled': 'Network "{network}" is not enabled or configured.',
    'Ft.SocialImport.UnsupportedNetwork': 'Network "{network}" is not supported.',
    'Ft.SocialImport.NotInSucceededStatus': 'The import did not complete successfully.',
    'Ft.NearbyVisibility.UpdateFailed': 'Failed to update nearby visibility.',
    'Ft.Translate.Failed': 'Translation failed.',
    'Notifications.DeviceAlreadyRegistered': 'This device is already registered for notifications.',
    PLAN_LIMIT_CONTACTS_REACHED:
      'You’ve reached the free plan limit of {limit} contacts. Upgrade to Keeptouch Infinity for unlimited contacts.',
    PLAN_LIMIT_GHOST_PROFILES_REACHED:
      'You’ve reached the free plan limit of {limit} ghost profiles. Upgrade to Keeptouch Infinity for unlimited ghost profiles.',
    PLAN_LIMIT_NOTES_REACHED:
      'You’ve reached the free plan limit of {limit} notes. Upgrade to Keeptouch Infinity for unlimited notes.',
    PLAN_LIMIT_REMINDERS_REACHED:
      'You’ve reached the free plan limit of {limit} reminders. Upgrade to Keeptouch Infinity for unlimited reminders.',
    PLAN_FEATURE_REMINDERS_DISABLED:
      'Reminders are a Keeptouch Infinity feature. Upgrade to Keeptouch Infinity so you never forget to keep in touch.',
  },
  common: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    statusOverdue: 'Past',
    statusUpcoming: 'Upcoming',
    statusDone: 'Done',
    all: 'All',
    cancel: 'Cancel',
    add: 'Add',
    save: 'Save',
    back: 'Back',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Confirm deletion',
    choose: 'Choose',
    validate: 'Validate',
    private: 'Private',
    pro: 'Pro',
    group: 'Group',
    personCount: '{count, plural, one {# person} other {# people}}',
    resultsCount: '{count, plural, one {# result} other {# results}}',
    contactCount: '{count, plural, one {# contact} other {# contacts}}',
    memberCount: '{count, plural, one {# member} other {# members}}',
    parenCount: ' ({count})',
    selectedCount: '{count} selected',
    shared: 'Shared',
    personal: 'Personal',
    filter: 'Filter',
    momentFilterAll: 'All',
    momentFilterToday: 'Today',
    momentFilterWeek: 'This week',
    momentFilterMonth: 'This month',
    momentFilterLater: 'Later',
    scanBusinessCard: 'Scan a business card',
    inCommon: 'In common',
    view: 'View',
    retry: 'Retry',
  },
  featureTooltip: {
    gotIt: 'Got it',
    conversation_ai_panel: {
      description:
        'Suggest: generates a reply. Summarize: a short overview. Analyze: sentiment and topics.',
    },
    scheduled_messages: {
      title: 'Scheduled messages',
      description:
        'Schedule messages to send later. AI can draft the message for you based on the reason (birthday, checking in…). Swipe to edit or delete.',
    },
    scheduled_msg_reason: {
      title: 'AI generation',
      description:
        'Choose a reason and add optional details. AI will write a personalized message suited to the context and your relationship with the contact.',
    },
    nearby_intro: {
      title: 'Contacts nearby',
      description:
        'See which contacts are near you, in the same city or country. Your location is updated automatically each time you connect.',
    },
    keep_contact: {
      title: 'Contact reminders',
      description:
        'Set reminders so you never forget to reach out again. Pick a date, recurrence, and filter by category or hashtag. Overdue reminders appear in red.',
    },
    graph_intro: {
      title: 'Relationship graph',
      description:
        'Explore your contacts and how they connect visually. Zoom, pan, and tap a contact to open their profile. Switch to Full mode to see links by category, hashtag, city…',
    },
    listing_contacts: {
      title: 'Your contacts',
      description:
        'Filter by Private or Pro using the tabs. Use + to add a contact manually, scan a business card, or import from a social network.',
    },
    card_scanner: {
      title: 'Business card scanner',
      description:
        'Take a photo or import a business card. AI will extract the details and create a new contact automatically.',
    },
    social_import: {
      title: 'Social contact import',
      description:
        'Pick a social network and enter a username. AI will import followers or contacts from that profile into your address book.',
    },
    merge_intro: {
      title: 'Merge duplicates',
      description:
        'AI finds duplicate contacts. Swipe right to merge, left to skip. Tap a profile to review it before you decide.',
    },
    classify_swipe: {
      title: 'Classify your contacts',
      description:
        'Swipe left for Private, right for Pro. You can also use the buttons. Tap the card to open the profile.',
    },
    chatbot_intro: {
      title: 'AI assistant',
      description:
        'Ask questions about your contacts, get suggestions, or take actions like scheduling a message. AI can search, analyze, and act for you.',
    },
  },
  graphScreen: {
    title: 'Relationship graph',
    nativeWebOnlyBody: 'Graph visualization is available on the web version.',
    nativeWebOnlySubtext: 'Sign in on keeptouch.co to explore your relationships interactively.',
    loadingGraph: 'Loading graph…',
    mode: 'Mode',
    modeContacts: 'Contacts',
    modeFull: 'Full',
    relations: 'Relations',
    statsLine: '{nodeCount} nodes · {edgeCount} links',
    edgeContact: 'Contacts',
    edgeCategory: 'Categories',
    edgeHashtag: 'Hashtags',
    edgeProfession: 'Professions',
    edgeNationality: 'Nationalities',
    edgeCity: 'Cities',
    legendMe: 'Me',
    legendPrivate: 'Private',
    legendPro: 'Pro',
    legendGhost: 'Ghost',
    legendCategory: 'Category',
    legendHashtag: 'Hashtag',
    legendProfession: 'Profession',
    legendNationality: 'Nationality',
    legendCity: 'City',
    searchPlaceholder: 'Search in the graph',
  },
  geolocation: {
    unavailable: {
      title: 'Geolocation unavailable',
      message: 'Geolocation is not available on this device.',
    },
    denied: {
      title: 'Permission denied',
      message:
        'We need access to your location to provide you with a better experience. Would you like to open settings to enable geolocation?',
      cancel: 'Cancel',
      settings: 'Settings',
    },
    blocked: {
      title: 'Permission blocked',
      message:
        'Access to geolocation has been blocked. Please go to the app settings to enable it manually.',
      cancel: 'Cancel',
      settings: 'Settings',
    },
  },
  contacts: {
    searchProfile: 'Search for a profile',
    addNonExistingProfile: 'Add a non-existing profile',
    importFromContacts: 'Import from my contacts',
    importFrom: 'Import from {network}',
    uncontact: 'Remove from my contacts',
    uncontactConfirmTitle: 'this contact',
  },
  settings: {
    title: 'Settings',
    language: 'Language',
    languageDescription: 'Choose the application language',
    auto: 'Automatic (device language)',
    french: 'Français',
    english: 'English',
    spanish: 'Español',
    location: 'Location',
    locationDescription: 'Manage access to your location',
    locationStatusUnknown: 'Status: not checked yet',
    locationStatusEnabled: 'Status: enabled',
    locationStatusDisabled: 'Status: disabled or unavailable',
    locationAction: 'Check location permission',
    locationToggle: 'Enable location',
    locationDenied: 'Location blocked by the browser. Allow it for this site.',
    subscription: 'Subscription',
    subscriptionDescription: 'Your current KeepTouch plan',
    subscriptionFree: 'Free plan',
    subscriptionManage: 'See Premium plans',
    subscriptionPremium: 'Premium active',
    calendarSync: 'Calendar sync',
    calendarSyncDescription: 'Add your KeepTouch events to your phone calendar.',
    calendarSyncEnable: 'Sync with my calendar',
    calendarSyncPermissionDenied: 'Calendar permission is required to sync.',
    deleteAccountTitle: 'Delete my account',
    deleteAccountDescription:
      'Permanently deletes your account and all your data. This action cannot be undone.',
    deleteAccountButton: 'Delete my account',
    deleteAccountConfirmTitle: 'Delete your account?',
    deleteAccountConfirmMessage:
      'This is permanent: your account and all your data (contacts, notes, messages…) will be deleted. You will not be able to recover them.',
    deleteAccountCancel: 'Cancel',
    deleteAccountConfirm: 'Delete permanently',
    deleteAccountInProgress: 'Deleting…',
    deleteAccountPasswordPlaceholder: 'Enter your password',
    deleteAccountWrongPassword: 'Incorrect password.',
    deleteAccountError: 'Account deletion failed. Please try again.',
  },
  calendarModal: {
    month0: 'January',
    month1: 'February',
    month2: 'March',
    month3: 'April',
    month4: 'May',
    month5: 'June',
    month6: 'July',
    month7: 'August',
    month8: 'September',
    month9: 'October',
    month10: 'November',
    month11: 'December',
    weekDay0: 'MON',
    weekDay1: 'TUE',
    weekDay2: 'WED',
    weekDay3: 'THU',
    weekDay4: 'FRI',
    weekDay5: 'SAT',
    weekDay6: 'SUN',
    time: 'Time',
    schedule: 'Schedule',
    subscriptionManage: 'See Premium plans',
    subscriptionPremium: 'Premium active',
  },
  connectedServices: {
    sectionTitle: 'Connected services',
    sectionDescription:
      'Connect your messaging accounts to automatically import your contacts into KeepTouch.',
    connect: 'Connect',
    connected: 'Connected',
    reconnect: 'Reconnect',
    statusConnecting: 'Connecting…',
    wizardOpened: 'Finish connecting in the tab that just opened, then come back here.',
    disconnect: 'Disconnect',
    disconnected: 'Service disconnected.',
    disconnectError: 'Disconnecting failed, please try again.',
    wizardError: 'Could not create the connection link, please try again.',
    refresh: 'Refresh',
    filterPlaceholder: 'Filter (optional): e.g. cybersecurity, finance, recruiting…',
    syncFilteredOut: '{filtered} contact(s) outside the filter were not imported',
    syncStarted: 'Import started — this can take a few minutes. No need to disconnect the service, it\u2019s coming! ⏳',
    syncInProgressHint: 'Import in progress… This can take a few minutes, you can keep using the app.',
    syncNow: 'Import my contacts',
    syncing: 'Importing…',
    syncResult: '{created} contact(s) imported, {skipped} already there',
    syncEmpty: 'No new contacts to import',
    syncError: 'The import failed, please try again.',
    planLimit: 'Free plan limit reached — some contacts were not imported.',
    noAccounts: 'No service connected yet.',
    serviceInstagram: 'Instagram',
    serviceWhatsapp: 'WhatsApp',
    serviceLinkedin: 'LinkedIn',
    serviceGmail: 'Gmail',
    calendarSync: 'Sync Google Calendar',
    calendarSyncing: 'Syncing…',
    calendarConnect: 'Connect Google Calendar',
    calendarSyncResult: '{created} event(s) imported, {skipped} already there',
    calendarSyncEmpty: 'Calendar already up to date',
    calendarSyncError: 'The sync failed, please try again.',
  },
  subscription: {
    title: 'Subscription',
    headline: 'Choose your Keeptouch experience',
    intro: 'Two plans to grow and nurture your human network, at your own pace.',
    // Free tier
    freeTierTitle: 'Free version',
    freeTierSubtitle: 'To discover Keeptouch and organize your first contacts.',
    freePriceLabel: 'Free',
    freeFeatureContacts: 'Up to 500 syncable contacts',
    freeFeatureGhosts: '30 ghost profiles',
    freeFeatureNotes: '10 personal notes maximum',
    freeFeatureReminders: '3 active reminders',
    freeFeatureMap: 'Relationship map in simplified version',
    freeFeatureNoStats: 'No statistics or smart insights',
    // Keeptouch Infinity
    infinityTierTitle: 'Keeptouch Infinity',
    infinityTierSubtitle: 'The complete experience for human-network builders.',
    infinityBadge: 'Recommended',
    infinityPriceFallback: '€6.99/month',
    infinityPricePerMonth: '{price}/month',
    infinityFeatureUnlimited: 'Everything unlimited',
    infinityFeatureGhosts: 'Unlimited ghost profiles',
    infinityFeatureAI: 'Relationship AI (link analysis, alerts, smart prioritization)',
    infinityFeatureIntegrations: 'Advanced integrations: WhatsApp, calendar, social networks',
    infinityFeatureMap: 'Dynamic, evolving network map',
    infinityFeatureForecast: 'Relationship evolution forecasts',
    infinityCta: 'Start Keeptouch Infinity',
    comingSoon: 'Coming soon',
    comingSoonMessage: 'Keeptouch Infinity is coming very soon. Thanks for your patience!',
    premiumTitle: 'You are Infinity',
    premiumSubtitle: 'Thanks for being part of Keeptouch Infinity. You enjoy every feature, with no limit.',
    premiumActive: 'Active subscription',
    expiresOn: 'Renews on {date}',
    processing: 'Processing…',
    activating: 'Activating your subscription…',
    purchaseSuccessTitle: 'Welcome to Keeptouch Infinity',
    purchaseSuccessMessage: 'Your subscription is active. Enjoy every feature!',
    purchaseErrorTitle: 'Purchase failed',
    purchaseErrorMessage: 'The purchase could not be completed. Please try again.',
    restoreCta: 'Restore purchases',
    restoring: 'Restoring…',
    restoreSuccessTitle: 'Subscription restored',
    restoreSuccessMessage: 'Your Infinity subscription has been restored.',
    restoreNoneTitle: 'Nothing to restore',
    restoreNoneMessage: 'We couldn’t find an active subscription on this account.',
    restoreErrorTitle: 'Restore failed',
    restoreErrorMessage: 'The restore could not be completed. Please try again.',
    manageCta: 'Manage my subscription',
    manageErrorTitle: 'Could not open',
    manageErrorMessage: 'Could not open the subscription management page.',
    legalDisclosure:
      'Auto-renewable monthly subscription at €6.99/month. It renews automatically unless cancelled at least 24 hours before the end of the period. You can cancel anytime in your account settings.',
    termsOfUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
  },
  planLimit: {
    title: 'Upgrade to Keeptouch Infinity',
    body: 'You’ve reached a free plan limit. Upgrade to Keeptouch Infinity to unlock this feature.',
    upgrade: 'Upgrade to Keeptouch Infinity',
    later: 'Maybe later',
  },
  export: {
    sectionTitle: 'Export my contacts',
    sectionDescription:
      'Download all your contacts as a vCard (.vcf) file, importable into any address book.',
    cta: 'Export my contacts (.vcf)',
    exporting: 'Exporting…',
    successTitle: 'Export complete',
    successMessage: 'Your contacts were exported as a vCard.',
  },
  recurrence: {
    title: 'Recurrence',
    custom: 'Custom',
    recurrence: 'Recurrence',
    every: 'Every',
    everyDay: 'Every day',
    everyWeek: 'Every week',
    every2Weeks: 'Every 2 weeks',
    every6Weeks: 'Every 6 weeks',
    everyMonth: 'Every month',
    every3Months: 'Every 3 months',
    every6Months: 'Every 6 months',
    everyYear: 'Every year',
    repeatOn: 'Repeat on',
    end: 'End',
    never: 'Never',
    on: 'On',
    after: 'After',
    lastDayOfMonth: 'Last day of month',
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year',
    repetition: 'repetition',
  },
  calendarEvent: {
    createEvent: 'Create an appointment',
    editEvent: 'Edit appointment',
    shared: 'Shared',
    sharedCount: 'Shared',
    personal: 'Personal',
    eventName: 'Appointment name',
    eventNamePlaceholder: 'Appointment name...',
    addGuests: 'Add guests',
    searchGuests: 'Search guests...',
    eventDate: 'Event date',
    allDay: 'All day',
    addLocation: 'Add a location',
    locationTitle: 'Location',
    description: 'Description',
    descriptionPlaceholder: 'Description...',
    alert: 'Alert',
    alertEnabled: 'Alert enabled',
    noAlert: 'No alert',
    inviteAndAdd: 'Invite and add to KeepTouch',
    addToCalendar: 'Add only to KeepTouch',
    addToGoogle: 'Add to Google Calendar',
    deleteConfirm: 'Delete this appointment?',
    markAsDone: 'Mark as done',
    markAsNotDone: 'Mark as not done',
  },
  ghostProfile: {
    inviteToJoin: 'Invite to join',
    inviteSent: 'Invitation sent by email.',
    inviteError: 'Could not send the invitation. Please try again.',
    inviteErrorNoEmail: 'This profile has no email address. Add an email to send an invitation.',
    editProfile: 'Edit profile',
    about: 'About',
    presentation: 'Presentation',
    birthday: 'Birthday',
    languages: 'Languages',
    nationalities: 'Nationalities',
    origins: 'Origins',
    contactInfo: 'Contact info',
    email: 'Email',
    phone: 'Phone',
    website: 'Website',
    availabilities: 'Availabilities',
    livedPlaces: 'Lived places',
    categories: 'Categories',
    searchCategories: 'Search categories',
    keepContact: 'Keep in touch',
    context: 'Context',
    hashtag: 'Hashtag',
    searchHashtags: 'Search hashtags',
    hashtags: 'Hashtags',
    objectives: 'Objectives',
    hobby: 'Hobby',
    skills: 'Skills',
    notes: 'Notes',
    appointments: 'Appointments / Reminders',
    memories: 'Memories',
    shareProfile: 'Share',
    message: 'Message',
    requestSent: 'Request sent',
    openOnKeepTouch: 'Open on KeepTouch',
    edit: 'Edit',
    deleteProfile: 'Delete profile',
    deleteConfirmTitle: 'this ghost profile',
    deleteSuccess: 'Ghost profile deleted',
    updateSuccess: 'Ghost profile updated',
    createSuccess: 'Ghost profile created',
    lastInteraction: 'Last interaction {time}',
    noInteractionYet: 'No interaction yet',
    viewMyProfile: 'View my profile',
    aboutProfile: 'About the profile',
    pins: 'Pins',
  },
  contextes: {
    title: 'Contexts',
    meetingContext: 'Meeting context',
    associatedEmotion: 'Associated emotion',
    relationshipEvolution: 'Relationship evolution',
    associatedColor: 'Associated color',
    referencePlace: 'Reference place',
    enterPlace: 'Enter a place',
    chooseMeetingContext: 'Choose the meeting context',
    editMeetingContext: 'Edit the meeting context',
    chooseEmotion: 'Choose the associated emotion',
    editEmotion: 'Edit the associated emotion',
    chooseRelationship: 'Choose the relationship evolution',
    editRelationship: 'Edit the relationship evolution',
    chooseColor: 'Choose the associated color',
    editColor: 'Edit the associated color',
    searchMeetingContext: 'Search a meeting context',
    searchEmotion: 'Search an associated emotion',
    searchRelationship: 'Search a relationship evolution',
    searchColor: 'Search an associated color',
    save: 'Save',
    unsavedTitle: 'Unsaved changes',
    unsavedMessage: "Are you sure you don't want to save?",
    leaveWithoutSaving: 'Leave without saving',
    keepEditing: 'Cancel',
  },
  categories: {
    notFound: 'Category not found',
    changePhoto: 'Change photo',
    chooseOption: 'Choose an option',
    gallery: 'Gallery',
    camera: 'Camera',
    person: 'person',
    persons: 'persons',
  },
  importContacts: {
    back: 'Back',
    importCard: 'Import a business card',
    businessCard: 'Business card',
    dragCard: 'Drag the business card here',
    or: 'Or',
    selectFiles: 'Select from your files',
    supportedFormats: 'Supported formats: PDF, JPEG, PNG',
    startImport: 'Start import',
    contactFound: 'Contact found on KeepTouch',
    profileFound: 'Profile found!',
    addNewContact: 'Add a new contact:',
    validate: 'Save the profile',
    validating: 'Saving…',
    checkInfo: 'Check the imported information',
    firstName: 'First name',
    enterFirstName: 'Enter first name',
    lastName: 'Last name',
    enterLastName: 'Enter last name',
    profession: 'Profession',
    enterProfession: 'Enter profession',
    company: 'Company',
    enterCompany: 'Enter company',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    website: 'Website',
    hashtag: 'Hashtag',
    hashtagPlaceholder: 'Name of #...',
    categoriesLabel: 'Categories',
    addNewContactButton: 'Add a new contact',
    searchProfession: 'Search a profession',
    file: {
      title: 'Import from a CSV file',
      subtitle:
        'Drop a CSV export from your CRM: a ghost profile will be created automatically for each contact.',
      drag: 'Drag your file here',
      formats: 'Supported format: CSV (.csv)',
      fullName: 'Full name',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      facebook: 'Facebook',
      twitter: 'Twitter / X',
      notes: 'Notes',
      unsupportedFormat: 'Unsupported format. Please choose a CSV (.csv) file. Export Excel files to CSV first.',
      empty: 'The file does not contain any contact rows.',
      parseError: 'Could not read the file. Make sure it is a valid CSV file.',
      detected: '{count} contact(s) detected in the file',
      columnsDetected: 'Columns recognised automatically:',
      noUsableRows: 'No usable rows: at least a name, email or phone is required.',
      importButton: 'Import {count} contact(s)',
      importing: 'Creating profiles… {done} / {total}',
      doneTitle: '{count} contact(s) imported successfully',
      doneDetails: '{skipped} row(s) skipped, {failed} failed',
      importAnother: 'Import another file',
      importedToast: '{count} ghost profile(s) created',
    },
  },
  contactsList: {
    noContactFound: 'No contact found',
    contactViaSocial: 'Contact via social networks',
  },
  socialNetwork: {
    contactViaLinkedin: 'Contact via LinkedIn',
    contactViaFacebook: 'Contact via Facebook',
    contactViaInstagram: 'Contact via Instagram',
    contactViaTwitter: 'Contact via Twitter',
  },
  keepContact: {
    editReminder: 'Edit follow-up',
    createReminder: 'Create a follow-up',
    reminderTitle: 'Follow-up title',
    reminderTitlePlaceholder: 'Follow-up name...',
    description: 'Description',
    descriptionPlaceholder: 'Description...',
    addContact: 'Add a contact',
    searchContact: 'Search for a contact...',
    contactLabel: 'Contact',
    eventDate: 'Event date',
    addLocation: 'Add a location',
    location: 'Location',
    alert: 'Alert',
    alertEnabled: 'Alert enabled',
    noAlert: 'No alert',
    alertActive: 'Active',
    alertInactive: 'Inactive',
    backToProfile: 'Back to profile',
    pageTitle: 'Keep in touch',
    reminder: 'follow-up',
    reminders: 'follow-ups',
    deleteConfirm: 'this follow-up',
    filter: 'Filter',
    none: 'None',
    keepContactWith: 'Keep contact with {contactName}',
    listView: 'List',
    boardView: 'Board',
  },
  recurrenceComponent: {
    everyDay: 'Every day',
    everyWeek: 'Every week',
    everyMonth: 'Every month',
    everyYear: 'Every year',
    recurrence: 'Recurrence',
    every: 'Every',
    repeatOn: 'Repeat on',
    monthDetail: 'Month detail',
    lastDayOfMonth: 'Last day of month',
    end: 'End',
    never: 'Never',
    on: 'On',
    after: 'After',
    day: 'day',
    days: 'days',
    week: 'week',
    weeks: 'weeks',
    month: 'month',
    year: 'year',
    years: 'years',
    repetition: 'repetition',
    repetitions: 'repetitions',
  },
  filters: {
    title: 'Filters',
    gender: 'Gender',
    age: 'Age',
    min: 'Min',
    max: 'Max',
    genderFemale: 'F',
    genderMale: 'M',
    genderNonBinary: 'NB',
    genderFemaleLong: 'Female',
    genderMaleLong: 'Male',
    genderNonBinaryLong: 'Non-binary',
    residence: 'Place of residence',
    residenceContinent: 'Continent',
    residenceCountry: 'Country',
    residenceRegion: 'Region',
    residenceCity: 'City',
    livedPlaces: 'Places lived',
    origin: 'Origin',
    nationality: 'Nationality',
    profession: 'Profession',
    meetingContext: 'Meeting context',
    associatedEmotion: 'Associated emotion',
    relationshipEvolution: 'Relationship evolution',
    associatedColor: 'Associated color',
    language: 'Language',
    category: 'Category',
    hashtag: 'Hashtag',
    searchPlace: 'Search for a place',
    activitySector: 'Activity sector',
    searchSector: 'Search for a sector',
    searchHashtags: 'Search hashtags',
    searchHashtag: 'Search for a hashtag',
    searchCategories: 'Search categories',
    searchCategory: 'Search for a category',
    searchMeetingContext: 'Search for a meeting context',
    searchEmotion: 'Search for an associated emotion',
    searchRelationship: 'Search for a relationship evolution',
    searchColor: 'Search for an associated color',
    searchLanguage: 'Search for a language',
  },
  photoAlert: {
    title: 'Choose a photo',
    message: 'Select an option',
  },
  qrCode: {
    shareMessage: 'Check out my KeepTouch profile: {url}',
    shareTitle: 'My KeepTouch profile',
    error: 'Error',
    shareError: 'Unable to share profile',
    success: 'Success',
    linkCopied: 'Link copied to clipboard',
    copyError: 'Unable to copy link',
    info: 'Information',
    downloadTodo: 'Download feature to be implemented',
    notKeepTouchUrl: 'This QR code does not contain a KeepTouch profile link.',
    scanTitle: 'Scan QR Code',
    scanInstruction: 'Point your camera at a KeepTouch QR code to scan it.',
    scanWebFallbackActive: 'Using alternative scanner for your browser.',
    cameraPermissionTitle: 'Camera access required',
    cameraPermissionMessage:
      'Please allow camera access in your browser settings to scan QR codes.',
  },
  webNav: {
    search: 'Search',
    allContacts: 'All my contacts',
    messaging: 'Messaging',
    notifications: 'Notifications',
    myProfile: 'My profile',
    signOut: 'Sign out',
    settings: 'Settings',
  },
  menuItems: {
    importContacts: 'Import contacts',
    classifyProfiles: 'Classify profiles',
    mergeProfiles: 'Merge profiles',
    maps: 'Maps',
    notes: 'Notes',
    categories: 'Categories',
    hashtags: 'Hashtags',
    relationalColors: 'Relational colors',
    appointments: 'Appointments / Reminders',
    birthdays: 'Birthdays',
    keepContact: 'Keep in touch',
    scheduledMessages: 'Scheduled messages',
    qrCode: 'QR code',
    settings: 'Settings',
    graph: 'Relationship graph',
    nearby: 'Nearby contacts',
  },
  form: {
    contactInfo: 'Contact info',
    about: 'About',
    woman: 'A woman',
    man: 'A man',
    mainInfo: 'Main information',
    firstName: 'First name',
    enterFirstName: 'Enter first name',
    lastName: 'Last name',
    enterLastName: 'Enter last name',
    professions: 'Profession(s)',
    enterProfession: 'Enter profession',
    company: 'Company',
    enterCompany: 'Company name (optional)',
    email: 'Email',
    phoneNumber: 'Phone number',
    socialNetworks: 'Social networks',
    website: 'Website',
    descriptionPlaceholder: 'Description...',
    presentation: 'Presentation',
    birthDate: 'Date of birth',
    livingPlace: 'Place of residence',
    origins: 'Origins',
    nationalities: 'Nationalities',
    nationalityPlaceholder: 'Nationality',
    spokenLanguages: 'Spoken languages',
    enterLanguages: 'Enter languages',
    livedPlaces: 'Lived places',
    hashtags: 'Hashtags',
    availabilityAndMeetings: 'Availability and meeting types',
    availability: 'Availability',
    bestMoment: 'Best moment',
    bestMoments: 'Best moments',
    chooseDay: 'Choose a day',
    chooseTime: 'Choose a time',
    days: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
    },
    searchLanguage: 'Search a language',
    searchPlace: 'Search a place',
    searchNationality: 'Search a nationality',
    searchHashtags: 'Search hashtags',
    searchCategories: 'Search categories',
    searchProfession: 'Search a profession',
    backToProfile: 'Back to profile',
    backToContacts: 'Back to contacts list',
    editGhostProfile: 'Edit ghost profile',
    createGhostProfile: 'Create ghost profile',
    addMeetingContext: 'Add meeting context',
    addNewContact: 'Add a new contact',
    addNewProfile: 'Add a new profile',
    addContact: 'Add a contact',
    searchContact: 'Search a contact...',
    addNonExistingProfile: 'Add a non-existing profile',
  },
  messaging: {
    searchPlaceholder: 'Search a message or contact',
    groupNamePlaceholder: 'Group name (optional)',
    recipientPlaceholder: 'Enter your recipient...',
    messagePlaceholder: 'Type your message...',
    aboutGroup: 'About the group',
    seen: 'Seen',
    createNewMessage: 'Create a new message',
  },
  profileEdit: {
    editMyProfile: 'Edit my profile',
    backToMyProfile: 'Back to my profile',
    about: 'About:',
    categories: 'Categories',
    searchCategories: 'Search categories',
  },
  livingPlaceForm: {
    editTitle: 'Edit place of residence',
    addTitle: 'Add place of residence',
    place: 'Place',
    startDate: 'Start date',
    endDate: 'End date',
    currently: 'Currently',
  },
  notesForm: {
    addNote: 'Add a note',
    editNote: 'Edit note',
    titlePlaceholder: 'Title',
    notePlaceholder: 'Note',
    sharedWith: 'Shared with ',
    addContact: 'Add a contact',
    selectContactTitle: 'Choose a contact',
    personalNote: 'Personal note',
    personalNoteSubtitle: 'For yourself',
  },
  hashtagForm: {
    addTitle: 'Add a hashtag',
    editTitle: 'Edit hashtag',
    backToList: 'Back to hashtags list',
    namePlaceholder: 'Name...',
  },
  deleteModal: {
    confirmMessage: 'Are you sure you want to delete {title}?',
    delete: 'Delete',
    cancel: 'Cancel',
  },
  relationalColorForm: {
    editTitle: 'Edit relational color',
    namePlaceholder: 'Name...',
  },
  addContactModal: {
    addPerson: 'Add {name}',
    addDefaultPerson: "Add person's name",
    addPrivate: 'Add as Private',
    addProfessional: 'Add as Professional',
    requestSent: 'Request sent',
  },
  addHashtagModal: {
    title: 'Add a hashtag',
    save: 'Save',
  },
  addCategoryModal: {
    title: 'Add a category',
    save: 'Save',
  },
  menuContactsList: {
    addContacts: 'Add contacts',
    linkedContacts: 'Linked contacts',
  },
  memoriesForm: {
    addPhoto: 'Add a photo',
    editMemory: 'Edit memory',
    addMemory: 'Add a memory',
    memory: 'Memory',
    selectMemory: 'Select a memory',
    description: 'Description:',
    identifyContacts: 'Identify contacts:',
    identifiedContacts: 'Identified contacts',
    publish: 'Publish',
    sharedMemories: 'Shared memories',
    sharedAlbums: 'Shared albums',
    deleteMemoryDescription: 'Do you want to delete only this photo, or the entire album?',
    deletePhoto: 'Delete this photo',
    deleteAlbum: 'Delete the album',
    deleteAlbumDescription: 'Are you sure you want to delete this entire album?',
  },
  albums: {
    title: 'Albums',
    createAlbum: 'Create album',
    albumName: 'Album name',
    albumTitle: 'Album title',
    defaultTitle: 'My album',
    description: 'Description',
    empty: 'No albums yet',
    deleteConfirm: 'Are you sure you want to delete this album?',
  },
  creationStack: {
    addNote: 'Add a note',
    conversation: 'Conversation',
    createEvent: 'Create an event',
    addReminder: 'Add a reminder',
    scheduleMessage: 'Schedule message',
    composeMessage: 'Compose message',
  },
  calendarAddEvent: {
    notActive: 'Not active',
    active: 'Active',
  },
  toast: {
    success: 'Success',
    error: 'Error',
    info: 'Info',
    scheduledMessageDeleted: 'Scheduled message deleted',
    scheduledMessageCreated: 'Scheduled message created',
    scheduledMessageUpdated: 'Scheduled message updated',
    reminderUpdated: 'Appointment / Reminder updated',
    reminderDeleted: 'Appointment / Reminder deleted',
    reminderCreated: 'Appointment / Reminder created',
    eventDeleted: 'Event deleted',
    eventCreated: 'Event created',
    eventUpdated: 'Event updated',
    colorUpdated: 'Color updated',
    contactRequestSent: 'Request sent',
    contactRequestSentMessage: 'Your friend request has been sent.',
    scopeChanged: 'Scope changed',
    categoryUpdated: 'Category updated',
    categoryCreated: 'Category created',
    categoryDeleted: 'Category deleted',
    noteCreated: 'Note created',
    noteUpdated: 'Note updated',
    noteDeleted: 'Note deleted',
    hashtagUpdated: 'Hashtag updated',
    hashtagDeleted: 'Hashtag deleted',
    hashtagCreated: 'Hashtag created',
    memoryCreated: 'Memory added',
    memoryUpdated: 'Memory updated',
    memoryDeleted: 'Memory deleted',
    albumCreated: 'Album created',
    albumDeleted: 'Album deleted',
  },
  voiceNote: {
    error: 'Error processing voice note',
    vocal: 'Vocal',
    successProfileUpdated: 'Profile updated',
    successNoteCreated: 'Note created',
    successProcessed: 'Voice note processed',
  },
  messagesScreen: {
    private: 'Private',
    pro: 'Pro',
    groups: 'Groups',
    other: 'Other',
    pinnedMessages: 'View pinned messages',
    viewNotes: 'View notes',
    viewMedia: 'View media',
    viewMembers: 'View members',
    customizeGroup: 'Customize group',
    share: 'Share',
    block: 'Block',
    report: 'Report',
    group: 'Group',
    members: 'Members',
    persons: '{count} people',
  },
  contactsScreen: {
    personFound: 'person found',
    personsFound: 'people found',
    noContactFound: 'No contact found',
    professionNotSpecified: 'Profession not specified',
    profilesRemainingToMerge: 'profiles remaining to merge',
    profileRemainingToMerge: 'profile remaining to merge',
    noProfileToMerge: 'No profile to merge',
    mergeProfiles: 'Merge profiles',
    merge: 'Merge',
    swipeToMerge: 'Swipe right to merge, left to skip.',
    swipeMergeInstruction: 'Swipe right to merge, left to skip.',
    profilesRemainingToClassify: 'profiles remaining to classify',
    profileRemainingToClassify: 'profile remaining to classify',
    noProfileToClassify: 'No profile to classify',
    classifyProfiles: 'Classify profiles',
    swipeToClassify: 'Swipe right or left to set the contact as professional or private.',
    swipeClassifyInstruction: 'Swipe right or left to set the contact as professional or private.',
    coordinates: 'Contact details',
    import: 'Import',
    importContacts: 'Import contacts',
    importAll: 'Import all',
    allContactsImported: 'All contacts have been imported',
    pleaseSyncContacts: 'Please sync your contacts',
    allImported: 'All contacts have been imported',
    syncContacts: 'Sync my contacts',
    selected: 'selected',
    contactFound: 'Contact found!',
    profileFound: 'Profile found!',
    contactFoundScan: 'Contact found!',
    profileFoundScan: 'Profile found!',
  },
  profileScreen: {
    noLivingPlaceAdded: 'No place of residence added',
    pressToAddFirstPlace: 'Tap + to add your first place',
    tapToAddFirstPlace: 'Tap + to add your first place',
    noDataAdded: 'No data added',
    noAvailabilityAdded: 'No availability added',
    noContactInfoAdded: 'No contact info added',
    noHashtagAdded: 'No hashtag added',
    backToMyProfile: 'Back to my profile',
    aboutSection: 'About:',
    uploadMemory: 'Upload your memory:',
    selectMemory: 'Select a memory',
    taggedContacts: 'Tagged contacts',
    contactTagged: 'Contact tagged:',
    contactsTagged: 'Contacts tagged:',
    startDate: 'Start date',
    endDate: 'End date',
    currently: 'Currently',
    cityOrCountryName: 'City or country name',
    duration: 'Duration',
    currentlyLivingHere: 'I currently live in this place',
  },
  notesScreen: {
    title: 'Notes',
    sharedNote: 'Shared note',
    personalNote: 'Personal note',
    shared: 'shared',
    personal: 'personal',
  },
  scheduledMessagesScreen: {
    private: 'Private',
    pro: 'Pro',
    groups: 'Groups',
    categoriesTab: 'Categories',
    title: 'Scheduled messages',
    results: '{count} results',
    scheduledFor: 'Scheduled for {time}',
    editing: 'Edit the message below',
    deleteConfirm: 'this scheduled message',
    createMessage: 'Create a message',
    chooseRecipient: 'Choose a recipient',
    typeMessage: 'Type a message',
    deleteScheduledMessage: 'Delete scheduled message',
  },
  hashtagsScreen: {
    notFound: 'Hashtag not found',
    newHashtag: 'New hashtag',
    person: '{count} person',
    persons: '{count} people',
    results: '{count} result',
    resultsPlural: '{count} results',
  },
  relationalColorsScreen: {
    title: 'Relational colors',
    notFound: 'Associated color not found',
    person: '{count} person',
    persons: '{count} people',
    results: '{count} result',
    resultsPlural: '{count} results',
  },
  categoriesScreen: {
    title: 'Categories',
    addSubcategory: 'Add a subcategory',
    subcategoryPhoto: 'Subcategory photo',
    subcategoryPlaceholder: 'Subcategory title...',
    categoryPhoto: 'Category photo',
    newCategory: 'New category',
    categoryTitlePlaceholder: 'Category title...',
    addCategory: 'Add a category',
    addSubcategoryWithPhoto: 'Add a subcategory',
    person: '{count} person',
    persons: '{count} people',
    backToList: 'Back to categories list',
  },
  notificationsScreen: {
    toAddPeople: 'to add people',
    acceptAsPro: 'Accept as professional',
    acceptAsPrivate: 'Accept as private',
    accept: 'Accept',
  },
  notifications: {
    friendRequest: 'Friend request',
    acceptedRequest: 'Request accepted',
    rejectedRequest: 'Request declined',
    upcomingEvent: 'Upcoming event',
    contactReminder: 'Keep in touch reminder',
    scheduledMessage: 'Scheduled message',
    birthday: 'Birthday',
    syncContacts: 'Sync my contacts',
    toAddPeople: 'To add people',
    all: 'All',
    requests: 'Requests',
    agenda: 'Agenda',
    accept: 'Accept',
    reject: 'Decline',
    accepted: 'Accepted',
    rejected: 'Declined',
    acceptAsPro: 'Accept as professional',
    acceptAsPrivate: 'Accept as private',
    orRejectRequest: 'Or decline the request',
    sections: {
      today: 'Today',
      thisWeek: 'This week',
      earlier: 'Earlier',
    },
    empty: {
      title: "You're all caught up",
      subtitle: 'You have no notifications right now.',
    },
  },
  mapScreen: {
    title: 'Map',
    contactFound: '{count} contact found in this area',
    contactsFound: '{count} contacts found in this area',
    contactsFoundInZone:
      '{count, plural, =0 {No contacts in this area} one {{count} contact found in this area} other {{count} contacts found in this area}}',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    zoomLevel: 'Zoom level',
  },
  birthdaysScreen: {
    title: 'Birthdays',
    upcoming: 'Upcoming birthdays',
    private: 'Private',
    pro: 'Pro',
    noBirthday: 'No birthday',
  },
  keepContactScreen: {
    private: 'Private',
    pro: 'Pro',
  },
  qrCodeScreen: {
    shareProfile: 'Share profile',
    copyLink: 'Copy link',
    download: 'Download',
  },
  webFooter: {
    legalNotice: 'Legal notice',
    contactUs: 'Contact us',
    privacyPolicy: 'Privacy policy',
    joinUs: 'Join us',
  },
  legalNotice: {
    editor: 'Publisher',
    editorContent:
      'KeepTouch SAS\nRegistered capital: €10,000\nHead office: Paris, France\nCompany registration number: RCS Paris\nPublication director: KeepTouch Team',
    hosting: 'Hosting',
    hostingContent:
      'The application is hosted by Amazon Web Services (AWS)\nAddress: 38 Avenue John F. Kennedy, L-1855 Luxembourg',
    intellectualProperty: 'Intellectual property',
    intellectualPropertyContent:
      'All content on the KeepTouch application (texts, images, logos, icons, software) is the exclusive property of KeepTouch SAS and is protected by French and international intellectual property laws. Any reproduction, representation, or distribution without prior written authorization is prohibited.',
    liability: 'Liability',
    liabilityContent:
      'KeepTouch SAS strives to provide accurate and up-to-date information. However, it cannot guarantee the accuracy, completeness, or timeliness of the information available on the application. KeepTouch SAS shall not be held liable for any direct or indirect damages resulting from the use of the application.',
  },
  contactUs: {
    description:
      'Do you have a question, a suggestion, or need assistance? Feel free to reach out to us. Our team will get back to you as soon as possible.',
    emailLabel: 'Email',
    email: 'contact@keeptouch.app',
    addressLabel: 'Address',
    address: 'KeepTouch SAS\nParis, France',
  },
  privacyPolicy: {
    introduction:
      'KeepTouch is committed to protecting the privacy and personal data of its users. This privacy policy describes how we collect, use, and protect your information.',
    dataCollection: 'Data collection',
    dataCollectionContent:
      'We collect data that you voluntarily provide when creating your account and using the application: name, email address, contacts, notes, reminders, and any other information you choose to share.',
    dataUsage: 'Data usage',
    dataUsageContent:
      'Your data is used exclusively to provide and improve the KeepTouch service. We do not sell or share your personal data with third parties for marketing purposes.',
    dataProtection: 'Data protection',
    dataProtectionContent:
      'We implement appropriate technical and organizational security measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.',
    cookies: 'Cookies',
    cookiesContent:
      'The application may use cookies and similar technologies to improve the user experience and analyze usage. You can manage your cookie preferences at any time from your settings.',
    rights: 'Your rights',
    rightsContent:
      'In accordance with the GDPR, you have the right to access, rectify, delete, and port your personal data. You also have the right to restrict and object to the processing of your data. To exercise these rights, contact us at: contact@keeptouch.app',
  },
  joinUs: {
    description:
      'KeepTouch is an innovative application dedicated to helping people maintain and strengthen their relationships. Join our team and contribute to a project that makes a difference!',
    whyJoin: 'Why join KeepTouch?',
    whyJoinContent:
      '• Work on an innovative project with social impact\n• Join a passionate and dynamic team\n• Flexible and remote-friendly work environment\n• Growth and development opportunities',
    positions: 'Open positions',
    positionsContent:
      'We are always looking for talented people to join our team. Current openings include:\n\n• Full-Stack Developer (React Native / NestJS)\n• UX/UI Designer\n• Marketing & Growth Manager\n• Community Manager',
    apply: 'How to apply',
    applyEmail: 'jobs@keeptouch.app',
  },
  emotionalContexts: {
    'affection-intimite': {
      name: 'Affection & Intimacy',
      description: 'These contacts nurture your heart.',
    },
    'aspiration-inspiration': {
      name: 'Aspiration & Inspiration',
      description: 'These contacts lift you up.',
    },
    'stimulation-aventure': {
      name: 'Stimulation & Adventure',
      description: 'These contacts bring movement and excitement to your life.',
    },
    'soutien-stabilite': {
      name: 'Support & Stability',
      description: 'These contacts support you emotionally and give you structure.',
    },
    'reflexion-profondeur': {
      name: 'Reflection & Depth',
      description: 'These contacts help you think, understand yourself, and grow.',
    },
    'lacher-prise-detente': {
      name: 'Letting go & Relaxation',
      description: 'These contacts help you breathe, disconnect, and exist without pressure.',
    },
    affection: 'Affection',
    'joie-chaleureuse': 'Warm joy',
    'tendre-complicite': 'Tender complicity',
    'presence-reconfortante': 'Comforting presence',
    'partage-authentique': 'Authentic sharing',
    aspiration: 'Aspiration',
    motivation: 'Motivation',
    source: 'Source',
    'elan-creatif': 'Creative impulse',
    'grandeur-ame': 'Greatness of soul',
    stimulation: 'Stimulation',
    aventure: 'Adventure',
    exploration: 'Exploration',
    'adrenaline-partagee': 'Shared adrenaline',
    fun: 'Fun',
    soutien: 'Support',
    encouragement: 'Encouragement',
    securite: 'Security',
    apaisement: 'Soothing',
    'croissance-lente': 'Slow growth',
    apprentissage: 'Learning',
    comprehension: 'Understanding',
    miroir: 'Mirror',
    'conscience-soi': 'Self-awareness',
    'conversations-vraies': 'True conversations',
    detente: 'Relaxation',
    legerete: 'Lightness',
    'presence-sans-enjeu': 'Presence without stakes',
    rire: 'Laughter',
    instantaneite: 'Spontaneity',
  },
  meetingContexts: {
    'education-formation': 'Education and training',
    educatif: 'Educational',
    formation: 'Training',
    etude: 'Study',
    'event-pro': 'Event and professional',
    event: 'Event',
    'event-pro-item': 'Professional event',
    networking: 'Networking',
    'etude-client': 'Client study',
    'sport-hobbies': 'Sports and hobbies',
    sportif: 'Sports',
    loisir: 'Leisure',
    festival: 'Festival',
    artistique: 'Artistic',
    'voyage-discovery': 'Travel and discovery',
    voyage: 'Travel',
    naturel: 'Nature',
    'relations-rencontres': 'Relationships and meetings',
    mariage: 'Wedding',
    'rencontre-sociale': 'Social meeting',
    'rencontre-famille': 'Family meeting',
    'rencontre-benevole': 'Volunteer meeting',
    'famille-proche': 'Close family',
    'event-online': 'Online event',
    eventSpecific: 'Specific event',
  },
  rrule: {
    custom: 'Custom',
  },
  relationshipStatus: {
    growing: 'Growing',
    stable: 'Stable',
    to_reconnect: 'To reconnect',
    fluctuating: 'Fluctuating',
    declining: 'Declining',
    ended: 'Ended',
  },
  nearby: {
    headerTitle: 'Nearby',
    pageTitle: 'Nearby contacts',
    perimeter10: 'Profiles within 10 km',
    perimeter50: 'Profiles within 50 km',
    perimeter100: 'Profiles within 100 km',
    perimeter10Short: 'Within 10 km',
    perimeter50Short: 'Within 50 km',
    perimeter100Short: 'Within 100 km',
    perimeterLabel: 'Perimeters',
    visibilityAll: 'You are currently visible to all users.',
    visibilityProfessional: 'You are currently visible to your professional contacts.',
    visibilityPrivate: 'You are currently visible to your private contacts.',
    visibilityHidden: 'You are currently not visible to anyone nearby.',
    visibilityAllMobile: 'Visible to all users.',
    visibilityProfessionalMobile: 'Visible to your professional contacts.',
    visibilityPrivateMobile: 'Visible to your private contacts.',
    visibilityHiddenMobile: 'Visible to no one.',
    visibilityLoading: 'Loading your visibility...',
    editVisibility: 'Edit my visibility',
    filterPrivate: 'Private',
    filterPro: 'Pro',
    emptyNoResults: 'No results.',
    emptyNoContacts: 'No nearby contacts found.',
    groupLabel: 'Profiles within {distance} km!',
    visibilityOptionAllTitle: 'Pro & Private',
    visibilityOptionAllDescription:
      'Your profile is visible to all users (professional and private).',
    visibilityOptionProTitle: 'Pro',
    visibilityOptionProDescription: 'Visible only to professionals and companies.',
    visibilityOptionPrivateTitle: 'Private',
    visibilityOptionPrivateDescription: 'Visible only to private users.',
    visibilityOptionHiddenTitle: 'Stay invisible',
    visibilityOptionHiddenDescription: 'Your profile is not shown to anyone nearby.',
    modalTitle: 'Edit my visibility',
    modalSubtitle: 'Choose who can see your profile on KeepTouch',
    modalHint: 'Check one or more options according to your needs.',
    updateButton: 'Update visibility',
    scopePrivate: 'Private',
    scopePro: 'Pro',
  },
  ai: {
    assistant: 'AI Assistant',
    tabSuggest: 'Suggest',
    tabSummarize: 'Summarize',
    tabAnalyze: 'Analyze',
    generateSuggestions: 'Generate suggestions',
    use: 'Use',
    summaryInProgress: 'Summarizing...',
    analysisInProgress: 'Analyzing...',
    sentiment: 'Sentiment',
    sentimentUndetermined: 'Undetermined',
    topics: 'Topics covered',
    dynamics: 'Dynamics',
    keyPoints: 'Key points',
    errorRetry: 'An error occurred. Try again.',
    instructionsPlaceholder: "Instructions (optional): e.g. 'formal tone', 'suggest a meeting'...",
    generatedByAi: 'Message generated by AI',
  },
  scheduledMessage: {
    create: {
      reasonQuestion: 'What is the reason for the message?',
      writeManually: 'Write it myself',
      recipientBadge: 'To',
      reasonBadge: 'Reason',
      additionalDetailsPlaceholder: 'E.g. He just landed a new job...',
      messageForContact: 'Message for {name}',
      additionalDetails: 'Additional details (optional)',
      scheduledFor: '{date} at {time}',
    },
    schedule: {
      programButton: 'Schedule',
    },
  },
  cardScan: {
    awaitingCamera: 'Waiting for camera...',
    allowCamera: 'Allow camera',
    retake: 'Retake',
    analyze: 'Analyze',
    dragDropPhoto: 'Drag and drop a photo of a business card here',
    orClickToSelect: 'or click to select a file',
  },
  qrCodeScan: {
    title: 'Scan a QR Code',
    headerTitle: 'QR Code',
  },
  ghostForm: {
    tagsSection: 'Tags',
    pinsSection: 'Pins',
    organizeProfile: 'Organize the profile',
    hashtagPlaceholder: 'Name of the #...',
    goalPlaceholder: 'Build a house...',
    profileHashtagsName: 'Profile hashtag',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
  },
  notes: {
    empty: {
      titleShared: 'No "shared" note',
      titlePersonal: 'No "personal" note',
      pressPlusToCreate: 'Tap + to create your first note',
    },
  },
  editCategory: {
    title: 'Edit a category',
    deleteConfirm: 'this category',
  },
  editHashtag: {
    deleteConfirm: 'this hashtag',
  },
  editNote: {
    deleteConfirm: 'this note',
  },
  ghostProfileExtra: {
    amisEnCommun: 'Mutual friends',
    inContactWith: 'In contact with {names}',
  },
  formExtra: {
    selectTime: 'Select a time',
    yourMessage: 'Your message...',
    chooseTime: 'Choose the time',
    cancel: 'Cancel',
  },
  filterHeader: {
    clear: 'Clear',
  },
  messagesPinned: {
    label: 'Pinned',
  },
  translate: {
    toggle: 'Translate',
    original: 'Original text',
    lang: {
      fr: 'French',
      en: 'English',
      es: 'Spanish',
    },
  },
  mergeSuggestions: {
    ghostBadge: 'Ghost',
    realBadge: 'Real contact',
    reason: {
      FullName: 'Same full name',
      LastName: 'Same last name',
      FirstName: 'Same first name',
      Email: 'Same email',
      Phone: 'Same phone',
      LinkedIn: 'Same LinkedIn',
      Instagram: 'Same Instagram',
      Facebook: 'Same Facebook',
      Twitter: 'Same Twitter',
    },
  },
  ftSocialImport: {
    title: 'Import from a social network',
    chooseNetwork: 'Choose a social network',
    usernameLabel: 'Username',
    linkedinNameLabel: "Person's name",
    startImport: 'Start the import',
    placeholder: {
      linkedin: 'First name Last name (e.g. Jane Doe)',
      facebook: 'URL or username (e.g. https://facebook.com/zuck)',
      twitter: 'URL or username (e.g. https://x.com/elonmusk)',
      instagram: 'Username (e.g. ethpas)',
      generic: 'Username',
    },
    launched: {
      title: 'Import started',
      message: 'The import has started. You can follow its progress from the contacts list.',
      networkMessage: 'The {network} import has started.',
    },
    error: {
      title: 'Error',
      startFailed: 'Could not start the import',
      validateFailed: 'Could not validate the selection',
      genericError: 'An error occurred',
    },
    previousImports: 'Previous imports',
    newImport: 'New import',
    inProgress: 'Import in progress…',
    failed: 'Failed',
    alreadyAdded: 'Already added',
    profilesFound: '{count, plural, one {# profile found} other {# profiles found}}',
    networkDescription: {
      linkedin: 'Enter the name of the person to search for',
      generic: 'Enter the {network} username to import their followers',
    },
    results: {
      title: 'Results — {network}',
      runningHint: 'This may take a few minutes',
      failedTitle: 'The import failed',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      validate: 'Validate selection ({count})',
      successTitle: 'Success',
      successMessage: '{count, plural, one {# profile imported} other {# profiles imported}}',
    },
  },
} as const

export type TranslationKeys = keyof typeof enTranslations
